import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/WholesaleAccount/WholesaleAccount.js
const WholesaleAccount = createSectionForm({
  icon: "account-box-line",
  title: "Wholesale Account",
  fields: [
    { name: "title", label: "Title" },
    { name: "button_text", label: "Button Text", placeholder: "Get A Wholesale Account" },
    {
      name: "form_url",
      label: "Form URL (opens in a popup)",
      placeholder: "https://survey.zohopublic.com/zs/7HCOiA",
    },
    { name: "description", label: "Description", type: "richtext" },
    { name: "image", label: "Image", type: "media" },
  ],
});

export default WholesaleAccount;
